import { Link, useParams } from "react-router-dom";
import Button from '@mui/material/Button';
import testimonialImage from '../Assets/Images/testimonial.png';
// import topQ from '../Assets/Images/topQ.svg';
import topQ from '../Assets/Images/leftQuote.png';
import bottomQ from '../Assets/Images/rightQuote.png';


const Testimonial = () => {

  const { id } = useParams();

  return (
    <>
      <div className="testimonial-container">
        <div className="testimonial">
        <div className="testi">
            <div className="quotation-mark"><img src={topQ} alt="open quote" /></div>
            <p>
              This assessment can help you understand your team's concerns about AI so you can align on the path forward; it helped us realise AI can empower and position our church for more significant impact.
            </p>
            {/* <p></p> */}
            
            <div className="quotation-mark bottom"><div className="quotation-block"><img src={bottomQ} alt="close quote" style={{transform:'rotate(180deg)'}} /></div></div>
            
          </div>
        <div>
          <div className="avatar">
            <img src={testimonialImage} alt="pastor" width={101} height={101} />
          </div>
        </div>
        <div style={{display:'flex', justifyContent:'center' , flexDirection:'column', alignItems:'center'}}>          
          <div className="designation">
          Sam Davis<p className="designation-inner">Senior Pastor, New Life Church</p> 
          </div>
        </div>
          {/* <div className="cta-btn">
          <Link to={"/invite-team/" + id} target="_blank">
          <Button>DISCOVER YOUR PRIORITY</Button>
          </Link>
        </div> */}

        </div>
      </div>
    </>
  );
}

export default Testimonial;
